import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useInjection } from "@presentation/components/dependencyInjection";
import { SaveLicenseService } from "@application/useCases/license/SaveLicenseService";
import { TYPES } from "@utils/inversifyJS/types";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";

/**
 * The about page with information about:
 * 1.The software version and build number;
 * 2.The list of third party libraries used;
 * 3.Allows user to paste and save a license key.
 * @returns Functional component
 */
const AboutPage: React.FC = () => {
  const [_, setFileContent] = useState<string>("");
  const [licenseKey, setLicenseKey] = useState("");
  const [saved, setSaved] = useState(false);
  const { t: loc } = useTranslation();

  const saveLicenseService = useInjection<SaveLicenseService>(TYPES.SaveLicenseService);

  useEffect(() => {
    const fetchFileContent = async () => {
      try {
        const response = await fetch("3rd-party-dependencies.txt", { cache: "no-store" });
        if (!response.ok) {
          throw new Error("Failed to load file");
        }
        const text = await response.text();
        setFileContent(text);
      } catch (error) {
        console.error(loc("errorMessage", String(error)));
      }
    };

    fetchFileContent();
  }, [loc]);


  const handleSaveLicenseKey = async () => {
    try {
      await saveLicenseService.execute(licenseKey);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
      setLicenseKey("");
    } catch (error) {
      console.error(loc("errorMessage", String(error)));
    }
  };

  return (
    <div>
      <div>
        <h3>OmicsFlow v{runtimeConfig.OMICSFLOW_GENERAL_VERSION}</h3>
        <div style={{ marginTop: 20 }}>
          <div style={{ marginTop: 10 }}>
            <input type="text" placeholder="Paste your Spectronaut license key" value={licenseKey} onChange={(e) => setLicenseKey(e.target.value)} style={{ width: 300, marginRight: 10 }} />
            <button onClick={handleSaveLicenseKey} disabled={!licenseKey.trim()}>
              Save
            </button>
          </div>
          {saved && <div style={{ color: "green", marginTop: 8 }}>License key saved!</div>}
        </div>
        <h3>Third party libraries</h3>
        <a href="https://biognosys.com/content/uploads/2025/12/ThirdPartyDependences_OmicsFlow.pdf">https://biognosys.com/content/uploads/2025/12/ThirdPartyDependences_OmicsFlow.pdf</a>
      </div>
    </div>
  );
};

export default AboutPage;
